import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function confirmPasswordValidator(passwordField: string, confirmPasswordField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordControl = control.get(passwordField);
    const confirmPasswordControl = control.get(confirmPasswordField);

    if (!passwordControl || !confirmPasswordControl) {
      return null; // Exit if form controls are not found
    }

    // If other errors exist on confirmPassword, return and don't override them
    if (confirmPasswordControl.errors && !confirmPasswordControl.errors['notSame']) {
      return null;
    }

    if (passwordControl.value !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ notSame: true });
    } else {
      confirmPasswordControl.setErrors(null);
    }

    return passwordControl.value !== confirmPasswordControl.value ? { notSame: true } : null;
  };
}
